<template>
    <LoadingCard v-if="loading" />
    <div v-else>
        <div class="toolbar">
            <div class="toolbar__label">
                Types of crops being grown
            </div>
        </div>

        <div class="card">
            <div class="card-header bg-primary text-white">
                Crop Types
            </div>
            <b-table small hover stacked="md" :items="allCropTypes" :fields="table.fields" sort-by="name" :show-empty="true"
                     @row-clicked="handleCropTypeToggle">
                <template slot="name" slot-scope="row">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input"
                               :id="`cropType${row.item.id}`" type="checkbox"
                               :checked="linkedCropTypes.includes(row.item.id)"
                        >
                        <label class="custom-control-label" :for="`cropType${row.item.id}`">{{ row.item.name }}</label>
                    </div>
                </template>

            </b-table>
        </div>

    </div>
</template>
<script>
import createProcessorCropTypeLinkMutation from '@views/Setup/CropTypeManager/mutationCreateProcessorCropTypeLink.graphql';
import deleteProcessorCropTypeLinkMutation from '@views/Setup/CropTypeManager/mutationDeleteProcessorCropTypeLink.graphql';
import listCropTypesQuery from '@views/Setup/CropTypeManager/queryListCropTypes.graphql';
import listProcessorLinkedCropTypesQuery from '@views/Setup/CropTypeManager/queryListProcessorLinkedCropTypes.graphql';

export default {
  name: 'ProcessorCropTypeManager',

  apollo: {
    allCropTypes: {
      query: listCropTypesQuery,
      update: data => data.filterCropTypes.data,
    },
    linkedCropTypes: {
      query: listProcessorLinkedCropTypesQuery,
      update: data => data.filterProcessorCropTypeLinks.map(item => item.id),
    },
  },
  data() {
    return {
      allCropTypes: [],
      linkedCropTypes: [],
      loading: 0,
      table: {
        fields: [
          { key: 'name', label: 'Crop Type', sortable: true },
        ],
      },
    };
  },
  methods: {

    handleCropTypeToggle(cropType) {
      if (this.linkedCropTypes.includes(cropType.id)) {
        this.unlinkCropType(cropType);
      } else {
        this.linkCropType(cropType);
      }
    },
    unlinkCropType(cropType) {
      this.$apollo.mutate({
        mutation: deleteProcessorCropTypeLinkMutation,
        variables: {
          input: {
            id: cropType.id,
          },
        },
        update: (
          store,
          { data: { deleteProcessorCropTypeLink: unlinkedCropType } },
        ) => {
          const data = store.readQuery({
            query: listProcessorLinkedCropTypesQuery,
          });
          const indexToRemove = data.filterProcessorCropTypeLinks.findIndex(
            item => item.id === unlinkedCropType.id,
          );
          if (indexToRemove !== -1) {
            data.filterProcessorCropTypeLinks.splice(indexToRemove, 1);
          }
          store.writeQuery({ query: listProcessorLinkedCropTypesQuery, data });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          deleteProcessorCropTypeLink: {
            __typename: 'CropType',
            blocks_count: 0,
            ...cropType,
          },
        },
      });
    },
    linkCropType(cropType) {
      this.$apollo.mutate({
        mutation: createProcessorCropTypeLinkMutation,
        variables: {
          input: {
            id: cropType.id,
          },
        },
        update: (
          store,
          { data: { createProcessorCropTypeLink: linkedCropType } },
        ) => {
          const data = store.readQuery({
            query: listProcessorLinkedCropTypesQuery,
          });
          data.filterProcessorCropTypeLinks.push(linkedCropType);
          store.writeQuery({ query: listProcessorLinkedCropTypesQuery, data });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          createProcessorCropTypeLink: {
            __typename: 'CropType',
            blocks_count: 0,
            ...cropType,
          },
        },
      });
    },
  },
};
</script>
